import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  return (
    <footer className="bg-dark text-white py-5">
        <div className="container">
            <div className="row g-4">
                <div className="col-md-4">
                    <h5 className="fw-bold mb-3">
                        <i className="bi bi-cup-hot-fill me-2"></i>Bella Vista
                    </h5>
                    <p className="">Serving exceptional cuisine with passion and dedication since 2010.</p>
                    <div className="social-links">
                        <Link to="https://www.facebook.com/" target="_blank" className="text-white me-3"><i className="bi bi-facebook fs-5"></i></Link>
                        <Link to="https://www.instagram.com/" target="_blank" className="text-white me-3"><i className="bi bi-instagram fs-5"></i></Link>
                        <Link to="https://www.youtube.com/" target="_blank" className="text-white"><i className="bi bi-youtube fs-5"></i></Link>
                    </div>
                </div>
                <div className="col-md-4">
                    <h5 className="fw-bold mb-3">Quick Links</h5>
                    <ul className="list-unstyled">
                        <li><Link to="/" style={{color:"white", fontWeight:"bold", fontSize:"16px"}} className="text-decoration-none">Home</Link></li>
                        <li><Link to="/about" style={{color:"white", fontWeight:"bold", fontSize:"16px"}} className=" text-decoration-none">About Us</Link></li>
                        <li><Link to="/menu" style={{color:"white", fontWeight:"bold", fontSize:"16px"}} className=" text-decoration-none">Menu</Link></li>
                        <li><Link to="/gallery" style={{color:"white", fontWeight:"bold", fontSize:"16px"}} className=" text-decoration-none">Gallery</Link></li>
                        <li><Link to="/contact" style={{color:"white", fontWeight:"bold", fontSize:"16px"}} className=" text-decoration-none">Contact</Link></li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h5 className="fw-bold mb-3">Contact Info</h5>
                    <p className=" mb-2">
                        <i className="bi bi-geo-alt-fill me-2"></i>123 Main Street, City, State 12345
                    </p>
                    <p className=" mb-2">
                        <i className="bi bi-telephone-fill me-2"></i>(555) 123-4567
                    </p>
                    <p className=" mb-2">
                        <i className="bi bi-envelope-fill me-2"></i>info@bellavista.com
                    </p>
                    <p className="">
                        <i className="bi bi-clock-fill me-2"></i>Mon-Sat: 11:00 AM - 10:00 PM
                    </p>
                </div>
            </div>
            <hr className="my-4 bg-secondary"/>
            <div className="text-center ">
                <p className="mb-0">&copy; 2025 Bella Vista Restaurant. All rights reserved.</p>
            </div>
        </div>
    </footer>
  )
}

export default Footer